// src/api/rapprochementApi.js
import axios from 'axios';

// URL de base de ton API (à adapter selon ton environnement)
const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

/**
 * Récupère la liste des relevés bancaires depuis l'API.
 * @returns {Promise<Array>} Liste des relevés bancaires.
 */
export const fetchReleveBancaire = async () => {
  try {
    const response = await axios.get(`${API_URL}/releve-bancaire`);
    return response.data;
  } catch (error) {
    console.error("Erreur lors de la récupération des relevés bancaires :", error);
    throw new Error("Impossible de charger les relevés bancaires.");
  }
};

/**
 * Récupère la liste des transactions enregistrées depuis l'API.
 * @returns {Promise<Array>} Liste des transactions.
 */
export const fetchTransactions = async () => {
  try {
    const response = await axios.get(`${API_URL}/transactions`);
    return response.data;
  } catch (error) {
    console.error("Erreur lors de la récupération des transactions :", error);
    throw new Error("Impossible de charger les transactions.");
  }
};

/**
 * Envoie les rapprochements validés à l'API pour sauvegarde.
 * @param {Object} data - Données des rapprochements à sauvegarder.
 * @returns {Promise<Object>} Réponse de l'API.
 */
export const saveRapprochement = async (data) => {
  try {
    const response = await axios.post(`${API_URL}/rapprochement`, data);
    return response.data;
  } catch (error) {
    console.error("Erreur lors de la sauvegarde des rapprochements :", error);
    throw new Error("Impossible de sauvegarder les rapprochements.");
  }
};
